import accountingReducer from './accounting.slice';
import clientReducer from './client.slice';
import { configureStore } from '@reduxjs/toolkit';
import driverSlice from './driver.slice';
import kpiSlice from './kpi.slice';
import lookupReducer from './lookup.slice';
import messageSlice from './messages.slice';
import monitoringReducer from './monitoring.slice';
import parentOrganizationsReducer from './parent-organizations.slice';
import passengerReducer from './passenger.slice';
import reservationReducer from './reservation.slice';
import securityReducer from './security.slice';
import settingsReducer from './settings.slice';
import triplegReducer from './tripleg.slice';
import uiReducer from './ui.slice';
import userReducer from './user.slice';
import providerReducer from './provider.slice';
import aiServicesReducer from './ai-services.slice';
/* Adapter enabled slices */
import { tripLegSlice } from './slices/trip-leg.slice';
import { reservationSlice } from './slices/reservation.slice';

const store = configureStore({
  reducer: {
    accounting: accountingReducer,
    aiServices: aiServicesReducer,
    client: clientReducer,
    driver: driverSlice,
    kpi: kpiSlice,
    lookup: lookupReducer,
    message: messageSlice,
    monitoring: monitoringReducer,
    parentOrganizations: parentOrganizationsReducer,
    passenger: passengerReducer,
    reservation: reservationReducer,
    reservationV2: reservationSlice.reducer,
    security: securityReducer,
    settings: settingsReducer,
    tripleg: triplegReducer,
    tripLegV2: tripLegSlice.reducer,
    ui: uiReducer,
    user: userReducer,
    provider: providerReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
